import RouteTemplate from 'ember-route-template'
import { PrintablesPage } from 'teacher-ui-client/components/page/printables'

export default RouteTemplate(PrintablesPage)
